import React, { createContext, FunctionComponent, useContext, useMemo } from "react";

interface PdfNavigationContextValue {
  navigateToPage: (page: number, bboxKey?: string) => void;
}

const PdfNavigationContext = createContext<PdfNavigationContextValue>({
  navigateToPage: () => {},
});

export const usePdfNavigation = (): PdfNavigationContextValue =>
  useContext(PdfNavigationContext);

export const PdfNavigationProvider: FunctionComponent<{
  navigateToPage: (page: number, bboxKey?: string) => void;
  children: React.ReactNode;
}> = ({ navigateToPage, children }) => {
  const value = useMemo(() => ({ navigateToPage }), [navigateToPage]);
  return (
    <PdfNavigationContext.Provider value={value}>
      {children}
    </PdfNavigationContext.Provider>
  );
};
